const backendUrl = process.env.VUE_APP_BACKEND_URL;

const state = {
  user: null
};

const mutations = {
  updateUser(state, user) {
    state.user = user;
  }
};

const actions = {
  async checkUser({ commit }) {
    try {
      const response = await fetch(`${backendUrl}/check_user`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });
      const data = await response.json();
      if (response.ok) {
        commit('updateUser', data);
        return 'success auth';
      }else if (response.status == 401 || response.status == 404) {
        return 'error auth'
      }
    } catch (error) {
      console.log(error)
      return 'error auth';
    }
  },
  async logout() {
    try {
      const response = await fetch(`${backendUrl}/logout`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });
      if (response.ok) {
        return 
      }else if (response.status == 401) {
        return 'error logout'
      }
    } catch (error) {
      console.log(error)
      return `error logout ${error}`;
    }
  }
};

export default {
  state,
  mutations,
  actions
};
